import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";

export default function CompaniesTrusted() {
  const [hoverIndex, setHoverIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  const leftNumDesktop = [1, 5, 9, 13];
  const rightNumDesktop = [4, 8, 12, 16];

  // Mobile detection
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Intersection Observer for inView detection
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      { threshold: 0.2 } // triggers when 20% of the section is visible
    );
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  const data = {
    alt: [
      "K12 Co-Op Logo",
      "K12 Rocket Logo",
      "Cricbuddy Logo",
      "AddressTwo Logo",
      "Tellos Logo",
      "MPC Logo",
      "SB Logo",
      "Johnson Eye Logo",
      "PathSolution Logo",
      "Berger's Logo",
      "Al-Wajeeh Logo",
      "Keuka Spring Logo",
      "Go-Cowork Logo",
      "The Heavy Weight Logo",
      "MarketWagon Logo",
      "Talk&Save Logo",
    ],
    title: [
      "Project K12 Co-Op",
      "Project K12 Rocket",
      "Project Cricbuddy",
      "Project AddressTwo",
      "Project Tellos",
      "Project MPC",
      "Project SB",
      "Project Johnson Eye",
      "Project PathSolution",
      "Project Berger's",
      "Project Al-Wajeeh",
      "Project Keuka Spring",
      "Project Go-Cowork",
      "Project The Heavy Weight",
      "Project MarketWagon",
      "Project Talk&Save",
    ],
  };

  return (
    <div ref={sectionRef} className="row py-md-5 py-2 mx-3_5-0">
      <div className="col-12 px-3">
        <h2 className="about-heading">
          Companies that have trusted us with their brand!
        </h2>
      </div>

      <div className="col-12 px-3">
        <div className="row flex-wrap justify-content-center mx-0">
          {[...Array(16)].map((_, index) => {
            const num = index + 1;
            const isHovered = hoverIndex === num;

            let borderClasses = "border brand-border";
            if (isMobile) {
              if (num % 2 !== 0) borderClasses += " border-start-0";
              else borderClasses += " border-end-0";
            } else {
              if (leftNumDesktop.includes(num))
                borderClasses += " border-start-0";
              if (rightNumDesktop.includes(num))
                borderClasses += " border-end-0";
            }

            return (
              <motion.div
                key={num}
                className={`col-md-3 col-6 p-3 ${borderClasses}`}
                initial={{ opacity: 0, y: 50 }}
                animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
              >
                {/* Desktop Image */}
                <img
                  src={`/images/AboutUs/Brands/${
                    isHovered ? "ClientHover" + num : "Client" + num
                  }.svg`}
                  alt={data.alt[num - 1]}
                  title={data.title[num - 1]}
                  className="img-fluid desktop"
                  onMouseEnter={() => setHoverIndex(num)}
                  onMouseLeave={() => setHoverIndex(null)}
                />

                {/* Mobile Image */}
                <img
                  src={`/images/AboutUs/Brands/ClientPhone${num}.svg`}
                  alt={data.alt[num - 1]}
                  title={data.title[num - 1]}
                  className="img-fluid mobile"
                />
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
